import Splide, { EVENT_CLICK } from "@splidejs/splide";

jQuery(document).ready(function () {
  //HEADER FUNCTIONALITIES
  var scroll = jQuery(window).scrollTop();
  headerScrollStyle(scroll);
  jQuery(window).scroll(function (event) {
    var scroll = jQuery(window).scrollTop();
    headerScrollStyle(scroll);
  });

  function headerScrollStyle(scrollHeight) {
    if (scrollHeight <= 40) {
      jQuery("header").css("top", "0");
      jQuery(".header_menu").css("height", "90px");
      jQuery(".header_logo").css("height", "126px");
    } else {
      jQuery("header").css("top", "-40px");
      jQuery(".header_menu").css("height", "64px");
      jQuery(".header_logo").css("height", "68px");
    }
  }

  jQuery(".mobile_menu div").first().addClass("mobile_menu__background");

  //menubutton
  let menuStatus = false;
  let processingMenu = false;
  jQuery("#menu_toggle_button").on("click", function () {
    if (menuStatus == false) {
      if (processingMenu == false) {
        menuStatus = true;
        processingMenu = true;
        jQuery(".mobile_menu").css("display", "block");
        jQuery("body").addClass("overflow-hidden");
        jQuery("#menu_toggle_button").css("transform", "rotate(180deg)");
        jQuery("#menu_toggle_button div:nth-child(1)").css(
          "transform",
          "translateY(14px) rotate(45deg)"
        );
        jQuery("#menu_toggle_button div:nth-child(2)").css("width", "0");
        jQuery("#menu_toggle_button div:nth-child(3)").css(
          "transform",
          "translateY(-14px) rotate(135deg)"
        );

        setTimeout(function () {
          jQuery(".mobile_menu__background").css("width", "100%");
          jQuery(".mobile_menu__background").css("height", "100%");
          jQuery(".mobile_menu__background").css("border-radius", "0");

          jQuery(".mobile_menu").addClass("mobile_menu_appear");
          setTimeout(function () {
            jQuery(".mobile_menu ul li").css("opacity", "1");
            jQuery(".mobile_menu button").css("opacity", "1");
            jQuery(".mobile_menu").removeClass("mobile_menu_appear");
            processingMenu = false;
          }, 500);
        }, 100);
      }
    } else {
      if (processingMenu == false) {
        menuStatus = false;
        processingMenu = true;

        jQuery(".mobile_menu").addClass("mobile_menu_dissappear");

        setTimeout(function () {
          jQuery(".mobile_menu ul li").css("opacity", "0");
          jQuery(".mobile_menu button").css("opacity", "0");
          jQuery(".mobile_menu").removeClass("mobile_menu_dissappear");
        }, 300);
        setTimeout(function () {
          jQuery(".mobile_menu").css("display", "none");
          processingMenu = false;
        }, 550);

        setTimeout(function () {
          jQuery("#menu_toggle_button").css("transform", "rotate(0deg)");
          jQuery("#menu_toggle_button div:nth-child(1)").css(
            "transform",
            "translateY(0) rotate(0deg)"
          );
          jQuery("#menu_toggle_button div:nth-child(2)").css("width", "100%");
          jQuery("#menu_toggle_button div:nth-child(3)").css(
            "transform",
            "translateY(0px) rotate(0deg)"
          );
          jQuery(".mobile_menu__background").css("width", "1%");
          jQuery(".mobile_menu__background").css("height", "1%");
          jQuery(".mobile_menu__background").css("border-radius", "50%");
          jQuery("body").removeClass("overflow-hidden");
        }, 200);
      }
    }
  });

  //SLIDER THREE ITEMS ON FRONT PAGE
  if (jQuery(".splide_frontpage").length) {
    let splideFrontpageOptions = {
      perPage: 3,
      drag: false,
      type: 'slide',
      padding: 0,
      focus: "center",
      speed: 600,
      easing: "cubic-bezier(0.65, 0, 0.35, 1)",
      pagination: false,
      flickPower: 600,
      arrows: false,
      breakpoints: {
        1280: {
          perPage: 1,
          pagination: true,
          drag: true,
          // type: 'loop',
          padding: '2rem',
        },
      },
    };

    if (jQuery(window).width() < 1280) {
      splideFrontpageOptions.perPage = 1;
      splideFrontpageOptions.pagination = true;
      splideFrontpageOptions.drag = true;
      // splideFrontpageOptions.type = 'loop';
      splideFrontpageOptions.padding = '3rem';
      // var windowSmall = true;
    }
    // else{
    //   var windowSmall = false;
    // }

    var frontPageSlider = new Splide(
      ".splide_frontpage",
      splideFrontpageOptions
    );

    frontPageSlider.mount();

    // console.log('Initial width: '+jQuery(window).width());
    
    // let windowWidth = jQuery(window).width();
  
    // jQuery( window ).on( "resize", function() {

    //   if (windowWidth > jQuery(window).width()) {
        
    //     if (!windowSmall){
    //       if (jQuery(window).width() < 1280) {
    //         console.log('Now Small! ' + jQuery(window).width());
    //         windowWidth = jQuery(window).width();
    //         windowSmall = true;

    //         splideFrontpageOptions.perPage = 1;
    //         splideFrontpageOptions.pagination = true;
    //         splideFrontpageOptions.drag = true;
    //         splideFrontpageOptions.type = 'loop';
    //         splideFrontpageOptions.padding = '3rem';

    //         frontPageSlider = new Splide(
    //           ".splide_frontpage",
    //           splideFrontpageOptions
    //         );
    //         frontPageSlider.mount();
    //         }
    //       }
    //     }
    //     else{
    //       if(windowSmall){
    //         if (jQuery(window).width() > 1280) {
    //           console.log('Now Wide! ' + jQuery(window).width());
    //           windowWidth = jQuery(window).width();
    //           windowSmall = false;

    //           splideFrontpageOptions.perPage = 3;
    //           splideFrontpageOptions.pagination = false;
    //           splideFrontpageOptions.drag = false;
    //           splideFrontpageOptions.type = 'slide';
    //           splideFrontpageOptions.padding = '0';

    //           frontPageSlider = new Splide(
    //             ".splide_frontpage",
    //             splideFrontpageOptions
    //           );
    //           frontPageSlider.mount();
    //           }
    //         }
    //       }
    // } );

  }

  //PHOTO SLIDER ON ABOUT PAGE
  if (jQuery(".about_photoslider").length) {
    var aboutSlider = new Splide(".about_photoslider", {
      type: "loop",
      height: "32rem",
      focus: "center",
      autoWidth: true,
      gap: "40px",
      speed: 600,
      easing: "cubic-bezier(0.65, 0, 0.35, 1)",
      autoplay: true,
      interval: 3000,
      arrows: false,
      pagination: false,
      pauseOnHover: false,
      breakpoints: {
        1280: {
          gap: "30px",
          height: "24rem",
        },
        480: {
          gap: "20px",
          height: "16rem",
        },
      },
    });
    aboutSlider.mount();

    aboutSlider.on("click", function (callback) {
      aboutSlider.go(callback.index);
    });
  }

  //MAP LEAFLET
  if (jQuery("#leafletmap").length) {
    const mapApikey =
      "pk.eyJ1IjoibHV1a2xpanRlbiIsImEiOiJja3l1NzdqMDcwNGc4Mm9tcDlrY3Iwang1In0.DWNcc1ywlyYFt08XZeT68Q";
    var map = L.map("leafletmap").setView(
      [51.608742377029735, 5.287055742621128],
      14.1
    );
    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18,
        minZoom: 5,
        id: "luuklijten/ckyuc21v3001o14qlj92tnyv8",
        tileSize: 512,
        zoomOffset: -1,
        accessToken: mapApikey,
      }
    ).addTo(map);

    const laserraSvgIcon = L.divIcon({
      html: `
    <a href="https://goo.gl/maps/uwp7QpipsxhFXiPR9" target="_blank">
      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M50,4.2A37.6,37.6,0,0,0,12.3,41.8c0,18.6,13.5,28.9,25.1,41L50,95.8l12.6-13c11.6-12.1,25.1-22.4,25.1-41A37.6,37.6,0,0,0,50,4.2Z" style="fill:#fff;stroke:#07612c;stroke-miterlimit:10;stroke-width:5px"/><path d="M23.4,45.7c.5-.2,1,.3,1.6.3,2.4.5,5.1,0,6.5-2.3h0c-3.1.2-5.5-1.5-7.6-3.5a.6.6,0,0,1-.1-.4c0-.2,0-.3.1-.4l.3-.2h.6c1.9,1.7,4,3.3,6.6,3.1H32c.7-3-1.5-5.6-4-7.1l-.2-.3v-.4l.2-.3.3-.2c.6-.2,1.1.5,1.7.8A8.2,8.2,0,0,1,33.5,42a25,25,0,0,1,5.5.4,20.5,20.5,0,0,1-1-6.5l-1.9.2a9.3,9.3,0,0,1-6.7-3.5.9.9,0,0,1-.1-.5c0-.1.1-.3.2-.3l.3-.2c.8-.1,1.1.7,1.7,1.1s4.4,2.6,6.7,1.6a8.2,8.2,0,0,0-3.6-6c-.4-.3-1.2-.6-1-1.3s.2-.3.4-.4.3-.1.4,0a.5.5,0,0,1,.4.2c2.3,1.6,4.4,3.9,4.7,6.6h.1a6,6,0,0,0,1.3-5.9,20,20,0,0,0-1-2.1V25l.2-.3a.5.5,0,0,1,.4-.2h.3c.6.3.7.9,1,1.4a8.1,8.1,0,0,1-.4,7.7L39.9,35a5.9,5.9,0,0,0,2.7,2.9,23.2,23.2,0,0,1,4.1,2.2c1.4-2,2.6-4.1,2.5-6.7v-1h-.1a6.8,6.8,0,0,1-5.3-4,10,10,0,0,1-.8-3.8.6.6,0,0,1,.1-.4l.3-.2h.7c.4.5.2,1.1.4,1.7a6.2,6.2,0,0,0,3.8,5l.8.2a4.9,4.9,0,0,0-.4-1.1c-.8-2.4,0-5.1.8-7.4l.3-.2h.7l.3.3c.1.3-.1.6-.1.8-1,2.3-1.4,5.4,0,7.6,2.5-.3,4.3-3,4.9-5.3.2-.5,0-1.3.6-1.5h.4l.3.2c.6.6,0,1.4-.1,2.1-.7,2.8-3,5.6-6.1,6-.4,3,.9,5.5,2.5,7.8.3-.1.5-.4.8-.6s3.6-1.3,5-3a8.6,8.6,0,0,0,1-1.6c-2.5-1.7-3.2-4.9-2.5-7.7a18.9,18.9,0,0,1,1.1-2.5l.3-.2h.3l.4.2c.1,0,.2.2.2.3s-.3,1-.5,1.5c-.9,2-1,4.8.6,6.5l.4.5a1.4,1.4,0,0,0,.2-.7c.5-2.5,2.6-4.7,4.7-6.2h.7c.1,0,.1.1.2.2a.4.4,0,0,1,.1.3c0,.2,0,.4-.2.5-1.9,1.5-3.9,3.3-4.2,5.8l-.2.8c3,1.3,5.9-.4,7.9-2.6h.7l.2.2c.1,0,.1.1.1.2s-.7,1.1-1.2,1.7-4.7,2.9-7.5,2.1a25,25,0,0,1-.9,6.6h.2a15.3,15.3,0,0,1,5.2-.4c-.4-3.4,2-6.5,4.9-8.1h.4l.3.2c0,.1.1.1.1.2s.1.2.1.3-1,.8-1.4,1.3c-2,1.5-3.5,3.7-2.9,6.3,2.9.4,5.3-1.2,7.4-3.2h.7l.2.2c0,.2.1.3.1.4s-.4.6-.6.8c-2,1.8-4.3,3.2-7.1,3.1h-.1A5.7,5.7,0,0,0,74.1,46l2.2-.5h.3l.3.2a1,1,0,0,1,.1.3v.3c-.3.6-1.1.6-1.7.8-3,.6-6.2-.1-8-2.7l-.4-.7a18.2,18.2,0,0,1-10,8.5,13.3,13.3,0,0,1-4.9.9l-.6.9V64.8a1,1,0,0,1-.4.7l-.7.4h-.8a1.8,1.8,0,0,1-.7-.5,1.2,1.2,0,0,1-.2-1V54.2a3.6,3.6,0,0,0-.7-1,18.5,18.5,0,0,1-14.2-8,5.4,5.4,0,0,1-.7-1.3,7.1,7.1,0,0,1-7.3,3.6,10.5,10.5,0,0,1-2.4-.6.2.2,0,0,1-.2-.2.4.4,0,0,1-.1-.3c0-.2,0-.3.1-.4S23.2,45.8,23.4,45.7Zm12-.5A18.3,18.3,0,0,0,46,51.7l-2.2-1.5a9.8,9.8,0,0,1-3.7-4.6,11.1,11.1,0,0,0-.7-1.6,21.6,21.6,0,0,0-5.1-.6A17.4,17.4,0,0,0,35.4,45.2Zm5.2-2.3a17.1,17.1,0,0,1,3.9,1.7h.1a17.9,17.9,0,0,1,1.3-3.2h0c-2-1.6-4.8-1.9-6.4-4.2a23.7,23.7,0,0,0,1.1,5.8Zm1.1,2.7c.7,2,2.8,3.4,4.5,4.4a6.6,6.6,0,0,1-1.7-3.8,19.1,19.1,0,0,0-3.2-1.6,10.4,10.4,0,0,0,.4,1ZM46,45c-.5,2.3,1.2,4,2.6,5.6-.1-2.9.2-6-1.6-8.2A20,20,0,0,0,46,45Zm1.8-3.9a8.9,8.9,0,0,1,2.1,5.1H50a9.3,9.3,0,0,1,2.1-5.1A28.2,28.2,0,0,1,50,37.3c-.6,1.3-1.5,2.5-2.2,3.8Zm4.3,2.7c-1.1,2.2-.5,4.3-.7,6.8a11.8,11.8,0,0,0,2.3-3.2c.8-1.8-.1-3.5-.8-5a5,5,0,0,0-.8,1.4ZM53.8,50l1.5-1a9.1,9.1,0,0,0,3.4-4.4,13.7,13.7,0,0,0-3.2,1.6A7.7,7.7,0,0,1,53.8,50Zm.1,1.6A13.1,13.1,0,0,0,58.6,50a16.2,16.2,0,0,0,7-6.7,18.1,18.1,0,0,0-5.2.7,14.7,14.7,0,0,1-1.9,4c-1.2,1.6-3,2.5-4.6,3.6Zm1.4-7a28.7,28.7,0,0,1,4-1.8A22.9,22.9,0,0,0,60.4,37c-1.5,2.5-4.4,2.6-6.5,4.3a12.2,12.2,0,0,1,1.4,3.3Z" style="fill:#f5a12d"/></svg>
    </a>
      `,
      className: "",
      iconSize: [75, 91],
      iconAnchor: [37.5, 91],
    });

    L.marker([51.60644262354406, 5.287171840989066], {
      icon: laserraSvgIcon,
    }).addTo(map);

    map.scrollWheelZoom.disable();
  }

  //Scrolldown vacancies
  jQuery(".vacancies_scrollbutton").click(function () {
    jQuery("html, body").animate(
      {
        scrollTop: jQuery(".vacancies_scrollto").offset().top - 100,
      },
      500
    );
  });

  // Assortment page jquery filters
  let ajaxStatus = false;
  jQuery(".pill").on("click", function () {
    if (!jQuery(this).hasClass("pill--active")) {
      if (!ajaxStatus) {
        ajaxStatus = true;

        jQuery(".product_grid").addClass("dissappear");
        jQuery(".product_grid").one(
          "webkitAnimationEnd oanimationend msAnimationEnd animationend",
          function () {
            jQuery(".product_grid").addClass("opacity-0");
            jQuery(".product_grid").removeClass("dissappear");
          }
        );

        jQuery(".pill").removeClass("pill--active");
        jQuery(this).addClass("pill--active");

        jQuery.ajax({
          type: "POST",
          url: jQuery(this).data("rooturl") + "/wp-admin/admin-ajax.php",
          dataType: "html",
          data: {
            action: "filter_products",
            category: jQuery(this).data("slug"),
          },
          success: function (res) {
            jQuery(".product_grid").html(res);

            jQuery(".product_grid").addClass("appear");
            jQuery(".product_grid").one(
              "webkitAnimationEnd oanimationend msAnimationEnd animationend",
              function () {
                jQuery(".product_grid").removeClass("opacity-0");
                jQuery(".product_grid").removeClass("appear");
              }
            );

            ajaxStatus = false;
          },
        });
      }
    }
  });

  //cookiebar

  function setCookie(cName, cValue, expDays) {
    let date = new Date();
    date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
  }

  jQuery("#cookie_button").on("click", function () {
    jQuery("#cookie_bar").addClass("dissappear_up");
    jQuery("#cookie_bar").one(
      "webkitAnimationEnd oanimationend msAnimationEnd animationend",
      function () {
        jQuery("#cookie_bar").remove();
      }
    );
    //set cookie
    setCookie("cookie_bar", true, 90);
  });


  //language menu switcher
  jQuery("#language_select__button").hover(function(){
    jQuery("#language_select__menu").slideToggle(100, 'swing');
  });

  //sub menu switcher in head menu
  jQuery(".header_menu__links li").hover(function(){
    if (jQuery(this).find('.sub-menu').length){
      jQuery(this).find('.sub-menu').slideToggle(100, 'swing');
    }
  });
  if (jQuery(".header_menu__links li").find('.sub-menu').length){
    jQuery('.header_menu__links li').find('.sub-menu').parent().find('> a').append('<i class="fas fa-chevron-down" style="margin-left: 8px; font-size: 0.875rem;"></i>');
    jQuery('.header_menu__links li').find('.sub-menu').parent().find('> a').removeAttr('href');
  }

  //sub menu switcher in mobile menu
  jQuery(".mobile_menu li").click(function(){
    if (jQuery(this).find('.sub-menu').length){
      jQuery(this).find('.sub-menu').slideToggle(100, 'swing');
    }
  });
  if (jQuery(".mobile_menu li").find('.sub-menu').length){
    jQuery('.mobile_menu li').find('.sub-menu').parent().find('> a').append('<i class="fas fa-chevron-down" style="margin-left: 8px; font-size: 1.25rem;"></i>');
    jQuery('.mobile_menu li').find('.sub-menu').parent().find('> a').removeAttr('href');
  }


});


// Mouse follow circle with lerp on homepage inspiration images
var mouseX=window.innerWidth/2, mouseY=window.innerHeight/2;

var circle = {
  el:jQuery('.inspiration_button'),
  x:window.innerWidth/2, y:window.innerHeight/2, w:jQuery('.inspiration_button').width(), h:jQuery('.inspiration_button').height(),
  update:function(){
    var l = this.x-this.w/2;
    var t = this.y-this.h/2;
    this.el.css({
      'transform':'translate3d('+l+'px, '+t+'px, 0)'
    });
  }
}

jQuery(window).mousemove (function(e){
  mouseX = e.clientX;
  mouseY = e.clientY;
})

jQuery('.inspiration_images').on('mouseenter', function () {
  circle.el.children().addClass('appear_zoom');
  circle.el.children().removeClass('dissappear_zoom');
});

jQuery('.inspiration_images').on('mouseleave', function () {
  circle.el.children().addClass('dissappear_zoom');
  circle.el.children().removeClass('appear_zoom');
});

setInterval (move,1000/60)

function move(){  
  circle.x = lerp (circle.x, mouseX, 0.1);
  circle.y = lerp (circle.y, mouseY, 0.1);
  circle.update() 
}

function lerp (start, end, amt){
  return (1-amt)*start+amt*end
}